import { useEffect, useState } from 'react'

import { DSButton, DSCircularLoading, DSModal, DSText } from '@vr/ds-react'
import { saveAs } from 'file-saver'
import JSZip from 'jszip'

import ModalError from '@/components/modal-error'

const ModalMenuFiles = ({
  unitId,
  onClose = () => {},
  files = []
}: {
  unitId: string
  onClose?: () => void
  files?: string[]
}) => {
  const [errorModal, setErrorModal] = useState(false)

  const handleZipDownload = async files => {
    const zip = new JSZip()

    if (!Array.isArray(files)) {
      files = [files]
    }

    for (const file of files) {
      const response = await fetch(file)

      const blobData = await response.blob()
      const fileName = file.split('/').pop() || 'file'
      const fileExtension = fileName.includes('.')
        ? `.${fileName.split('.').pop()}`
        : ''

      zip.file(`${unitId}_file${fileExtension}`, blobData)
    }

    const zipData = await zip.generateAsync({ type: 'blob' })

    saveAs(zipData, `${unitId}_files.zip`)
  }

  useEffect(() => {
    if (!files || files.length === 0) {
      setErrorModal(true)
      return
    }

    handleZipDownload(files)
      .then(() => {
        onClose()
      })
      .catch(() => {
        setErrorModal(true)
      })
  }, [files])

  return (
    <>
      <DSModal config={{ show: true, onClose }} css={{ width: '500px' }}>
        <DSModal.Header onClose={onClose}>Arquivo</DSModal.Header>
        <DSModal.Body>
          <DSCircularLoading isLoading shouldBlur={false} />
        </DSModal.Body>
        <DSModal.Footer css={{ display: 'flex', justifyContent: 'end' }}>
          <DSButton variant='secondary' onClick={onClose}>
            Fechar
          </DSButton>
        </DSModal.Footer>
      </DSModal>

      {errorModal && (
        <ModalError
          isOpen={errorModal}
          title='Erro ao baixar o arquivo'
          onClose={() => {
            setErrorModal(false)
            onClose()
          }}
        >
          <DSText>
            Não foi possível baixar o arquivo. Por favor, tente novamente mais
            tarde.
          </DSText>
        </ModalError>
      )}
    </>
  )
}

export default ModalMenuFiles
